import { Observable,  BehaviorSubject,  ReplaySubject } from 'rxjs'
import { map, debounceTime, distinctUntilChanged, take } from 'rxjs/operators'

import { Injectable } from '@angular/core';
// import { Router } from '@angular/router';
import { CookieService } from './cookie.service';

const ACCESS_TOKEN_KEY: string = 'lcp_access_token'
const REFRESH_TOKEN_KEY: string = 'lcp_refresh_token'
const GOOGLE_TOKEN_KEY: string = 'idToken'

@Injectable()
export class TokenService {

  logoutTimeout: any

  private tokenSubject = new BehaviorSubject<any>(null)
  public token = this.tokenSubject.asObservable().pipe(distinctUntilChanged())
  private tokenLocal: any

  private tokenDataSubject = new ReplaySubject<any>(1)
  public tokenData = this.tokenDataSubject.asObservable() //.pipe(distinctUntilChanged())
  private tokenDataLocal: any
  
  constructor(
    private cookieService: CookieService
  ) {}

  public get accessTokenKey() { return ACCESS_TOKEN_KEY }
  public get refreshTokenKey() { return REFRESH_TOKEN_KEY }
  public get googleTokenKey() { return GOOGLE_TOKEN_KEY }

  getToken(): string {
    // return localStorage.getItem(ACCESS_TOKEN_KEY);
    return this.cookieService.get('local', ACCESS_TOKEN_KEY)
  }
  getRefreshToken(): string {
    // return localStorage.getItem(REFRESH_TOKEN_KEY);
    return this.cookieService.get('local', ACCESS_TOKEN_KEY)
  }

  clearLogoutTimeout() {
    if (this.logoutTimeout) window.clearTimeout(this.logoutTimeout)
  }


  updateToken(token: any) {
    // console.log('updatingToken', ACCESS_TOKEN_KEY, token)
    this.cookieService.set('local', ACCESS_TOKEN_KEY, token)
    this.tokenSubject.next(token)
    this.tokenLocal = token

    this.updateTokenData(this.parseToken(token))
  }

  updateTokenData(data: any) {
    this.tokenDataSubject.next(data)
    this.tokenDataLocal = data
  }

  saveRefreshToken(token): void {
    // localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    return this.cookieService.set('local', REFRESH_TOKEN_KEY, token)
  }

  removeToken(): void {
    this.updateToken(null)
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    return this.cookieService.delete('local', ACCESS_TOKEN_KEY)
  }

  removeRefreshToken(): void {
    return this.cookieService.delete('local', REFRESH_TOKEN_KEY)
  }

  parseToken(token: string) {
    if (!token) return null
    try {
      let atb = atob(token.split('.')[1])
      return JSON.parse(atb) // atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  }

  
}
